import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// lightGallery plugins
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';

declare var lightGallery: any;

@Component({
  selector: 'app-ek-sham-geeto-ke-naam',
  templateUrl: './ek-sham-geeto-ke-naam.component.html',
  styleUrls: ['./ek-sham-geeto-ke-naam.component.scss']
})
export class EkShamGeetoKeNaamComponent implements OnInit, AfterViewInit {

  // Model bound to the form
  user = { name: '', email: '', password: '' };

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  // Submit registration data to API
  onSubmit() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // If your API needs auth, add here:
      // 'Authorization': 'Bearer your_token_here'
    });

    this.http.post('https://ghrscf.com/api/ek-sham-geeto-ke-naam', this.user, { headers })
      .subscribe({
        next: (res) => {
          console.log('✅ Registration successful:', res);
          alert('Registration successful!');
        },
        error: (err) => {
          console.error('❌ Error:', err);
          alert('Registration failed!');
        }
      });
  }

  // Initialize lightGallery after view loads
  ngAfterViewInit() {
    // Video galleries
    let galleries = document.getElementsByClassName('video-gallery');
    for (let i = 0; i < galleries.length; i++) {
      galleries[i].id = 'gal' + i;
      lightGallery(document.getElementById('gal' + i), { selector: 'a' });
    }

    // Image galleries
    let gallImage = document.getElementsByClassName('lightgallery');
    for (const gal of Array.from(gallImage)) {
      lightGallery(gal, { selector: 'a' });
    }
  }
}
